import { translate } from 'infras/i18n';
import styled from '@emotion/styled';
import { spacing, fontSize } from 'presentations/views/styles';
import { error } from 'presentations/views/styles/color';

interface Props {
  children?: string;
}

export default function Component(props: Props) {
  if (!props.children) return null;
  return <ErrorText>{translate(props.children)}</ErrorText>;
}

const ErrorText = styled.div`
  font-size: ${fontSize(12)};
  margin-top: ${spacing(4)};
  color: ${error};
`;
